import React, { useEffect, useRef, useState } from 'react';
import crosssimgiocn from "../../Images/crosssimgiocn.png"
import Neoologoasjji from "../../Images/Neoologoasjji.png";
// import postbanneimmhg from "../../Images/postbanneimmhg.png";
import postbanneimmhg from "../../Images/cameralogo.png";
// import prodlikeicon from "../../Images/prodlikeicon.png";
// import prodlikedicon from "../../Images/liked.png";
// import commenytstproodiuificon from "../../Images/commenytstproodiuificon.png";
// import msgiocn from "../../Images/msgiocn.png";
// import Photography from "../../Images/Photography.png";
// import logiiaihsui from "../../Images/logiiaihsui.png";
// import cntnctimg3 from "../../Images/cntnctimg3.png";
// import cmtprofiletwoimg from "../../Images/cmtprofiletwoimg.png"
// import Ownpostpagemodal from '../../Modal/Ownpostpagemodal';
// import HttpClient from '../../utils/HttpClient';
import { formatDateAgo } from '../../utils/Helper';
import { useDispatch, useSelector } from 'react-redux';
import ItemLoader from '../../Component/ItemLoader';
// import PostComments from './PostComments';
// import PostEnqueyModal from '../../Modal/PostEnqueyModal';
import { getSingleUserProfile, SetDisplayUserData, ShareModalonOff } from '../../Redux/Slice/PostSlice';
import { useLocation, useNavigate, useParams, Link } from 'react-router-dom';
import toast from 'react-hot-toast';
// import ProfileShare from '../../Modal/ProfileShare';
import { deletePageEnquiry, fetchPageEnquiries } from '../../Redux/Slice/EnquirySlice';
import moment from 'moment';

const BlmPageEnquiries = ({ filter, setCounter }) => {
    const { status, PageEnquiries } = useSelector((state) => state.enquiry);
    const { UserProfileID } = useSelector((state) => state.app);

    const dispatch = useDispatch()
    const navigate = useNavigate()
    const params = useParams()

    // const [loadmtersdiumodal, setLoadmtersdiumodal] = useState(false);
    const [handleownpostmodal, sethandleownpostmodal] = useState(false)
    // const loadmoresfgbtbnbclokj = () => {
    //     setLoadmtersdiumodal(!loadmtersdiumodal)
    // }
    const [threedpotsspclmodal, setThreedpotsspclmodal] = useState(false);
    const [ownpostcommetclickmodal, setownpostcommetclickmodal] = useState(false)

    const [menuPostID, setMenuPostID] = useState()
    // const threedotssettingclcil = (e, id) => {
    //     e.preventDefault()
    //     setMenuPostID(id)
    //     threedpotsspclmodal ? setThreedpotsspclmodal(true) : setThreedpotsspclmodal(!threedpotsspclmodal)
    //     // setThreedpotsspclmodal(true)

    // }

    const [commentPostID, setCommentPostID] = useState()
    const ownposcommentclcik = (e, id) => {
        e.preventDefault()
        setCommentPostID(id)
        ownpostcommetclickmodal ? setownpostcommetclickmodal(true) : setownpostcommetclickmodal(!ownpostcommetclickmodal)
        // setownpostcommetclickmodal(true)
        // setThreedpotsspclmodal(!threedpotsspclmodal)
    }

    const [queryPostID, setQueryPostID] = useState()
    const [sendQueryModal, setSendQueryModal] = useState(false)
    // const handleQuery = (e, id, userId) => {
    //     e.preventDefault()
    //     setQueryPostID(id)
    //     UserProfileID?._id !== userId && setSendQueryModal(!sendQueryModal)
    // }

    const [selectedPostData, setSelectedPostData] = useState()
    // const handleopwmnpostmodal = (e, item) => {
    //     e.preventDefault()
    //     setSelectedPostData(item)
    //     sethandleownpostmodal(!handleownpostmodal)
    // }

    //Display Posts
    // const [allData, setAllData] = useState([])

    const [visibleItems, setVisibleItems] = useState([]);
    const [itemsToShow, setItemsToShow] = useState(3);
    // const loadMoreItems = 1;
    // const handleLoadMore = () => {
    //     // Load more items by increasing the itemsToShow count
    //     setItemsToShow((prev) => prev + loadMoreItems);
    // };

    useEffect(() => {
        // getMyBusinessPosts()
        // params.id && !UserProfileID ? navigate('/user-login') :
        UserProfileID ? dispatch(fetchPageEnquiries()) : navigate('/user-login')

    }, [])

    useEffect(() => {
        // setVisibleItems(PageEnquiries.slice(0, itemsToShow));

        const today = new Date();

        if (filter === "today") {
            // Format today's date to YYYY-MM-DD
            const todayString = today.toISOString().split("T")[0];
            setVisibleItems(
                [...PageEnquiries]
                    .filter((post) => {
                        // Extract only the date part from createdOn
                        const createdDate = post.createdOn.split("T")[0];
                        return createdDate === todayString;
                    })
                // .slice(0, itemsToShow)
            )
        } else if (filter === "week") {
            // Get the first day of the current week (Sunday)
            const startOfWeek = new Date(today);
            startOfWeek.setDate(today.getDate() - today.getDay());
            startOfWeek.setHours(0, 0, 0, 0); // Set to start of the day

            // Get the last day of the current week (Saturday)
            const endOfWeek = new Date(startOfWeek);
            endOfWeek.setDate(startOfWeek.getDate() + 6);
            endOfWeek.setHours(23, 59, 59, 999); // Set to end of the day

            setVisibleItems(
                [...PageEnquiries]
                    .filter((post) => {
                        const createdDate = new Date(post.createdOn);
                        return createdDate >= startOfWeek && createdDate <= endOfWeek;
                    })
                // .slice(0, itemsToShow)
            )
        } else if (filter === "month") {
            const currentMonth = today.getMonth(); // 0-based index (0 = January)
            const currentYear = today.getFullYear();

            setVisibleItems([...PageEnquiries]
                .filter((post) => {
                    const createdDate = new Date(post.createdOn);
                    return (
                        createdDate.getMonth() === currentMonth && createdDate.getFullYear() === currentYear
                    );
                })
                // .slice(0, itemsToShow)
            )
        } else {
            setVisibleItems(
                [...PageEnquiries]
                // .slice(0, itemsToShow)
            )
        }
    }, [itemsToShow, PageEnquiries, filter]);

    useEffect(() => {
        setCounter(visibleItems.length)
    }, [visibleItems])


    // const [likeCounter, setLikeCounter] = useState(0)
    // const [isLikeByMe, setIsLikeByMe] = useState(false)
    // const [activePostId, setActivePostId] = useState("")



    // const handlePostLike = async (e, data) => {
    //     e.preventDefault()
    //     if (UserProfileID?._id === data?.profileId) return
    //     try {
    //         const response = await HttpClient.requestData(
    //             "business-post-like",
    //             "POST",
    //             { postId: data?._id }
    //         );
    //         if (response.status) {
    //         } else {
    //             console.error("Error in Like/Dislike");
    //         }
    //     } catch (error) {
    //         console.error("Error submitting Like/Dislike:", error);
    //     } finally {
    //         // dispatch(LoadBusinessPostsInBackground())
    //     }
    // }

    const gotoBusinessListing = (e, user) => {
        e.preventDefault()
        dispatch(getSingleUserProfile(user?._id))
        navigate(`/businesspage/${user?.companySlug}`)

        // alert(userId)
    }

    const hidePost = (e) => {
        e.preventDefault()
        setThreedpotsspclmodal(false)
    }

    const location = useLocation();
    const copyPostLink = (e, postId) => {
        e.preventDefault()
        const postUrl = `${window.location.origin}/ownpostpage/${postId}`;
        if (navigator.clipboard && navigator.clipboard.writeText) {
            navigator.clipboard.writeText(postUrl).then(() => {
                toast.success("Copied Successfully");
                setThreedpotsspclmodal(false)
            });
        } else {
            toast.error("Clipboard not supported in this browser.")
        }
    }
    const [sharemodal, setSharemodal] = useState(false);
    const [postLink, setPostLink] = useState("")
    const shareClick = (e, postId) => {
        e.preventDefault()
        const postUrl = `${window.location.origin}/ownpostpage/${postId}`;
        setPostLink(postUrl)
        setSharemodal(!sharemodal);
        dispatch(ShareModalonOff(true));
    };

    const divRef = useRef(null);
    const handleClickOutside = (e) => {
        // Check if the click is outside the referenced div
        if (divRef.current && !divRef.current.contains(e.target)) {
            // Call your method here
            // alert(1)
            setThreedpotsspclmodal(false)
        }
    };
    useEffect(() => {
        // Add event listener when the component mounts
        document.addEventListener('mousedown', handleClickOutside);
        return () => {
            // Cleanup the event listener when the component unmounts
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, []);

    const [isModalOpen, setIsModalOpen] = useState(false);
    const [selectedImage, setSelectedImage] = useState(null);

    const openModal = (image) => {
        setSelectedImage(image);
        setIsModalOpen(true);
    };

    const closeModal = () => {
        setSelectedImage(null);
        setIsModalOpen(false);
    };

    const [actDelete, setActDelete] = useState(false)
    const deleteEnquiry = async (e, id) => {
        e.preventDefault()
        setActDelete(true)
        dispatch(deletePageEnquiry(id))
        dispatch(fetchPageEnquiries())
    }

    const handleSingleData = (e, item) => {
        // dispatch(SetDisplayUserData([item]))
        // const link = item?.companySlug || item?.companyName?.toLowerCase().replace(/\s+/g, "_");
        // navigate(`/businesspage/${link}`)
        console.log("item", item)
        const link = item?.userName ? `/profile/${item?.userName}` : `#`;
        navigate(link)
    }

    return (
        <>
            {
                status === "loading" && !actDelete ? (
                    <>
                        <ItemLoader />
                    </>
                ) : (
                    <>
                        <div className='allpostowndmaimndivmain'>
                            {
                                visibleItems.map((enquiryItem, index) => {
                                    return (
                                        <>
                                            <div className='allpostowndmaimndiv' key={index}>
                                                <div className='allpostimagedesuigfnatinob' style={{ marginBottom: "5px", paddingBottom: "5px", }}>
                                                    <div className='allposttslodjjimg'>
                                                        <Link
                                                            to={enquiryItem?.enqueryByData?.userName ? `/profile/${enquiryItem?.enqueryByData?.userName}` : `#`}
                                                            className="profileLink">
                                                            <img src={enquiryItem?.enqueryByData?.profilePhoto || Neoologoasjji} alt={enquiryItem?.enqueryByData?.userName} />
                                                        </Link>
                                                    </div>
                                                    <div className='' onClick={(e) => handleSingleData(e, enquiryItem?.enqueryByData)} style={{ cursor: "pointer" }} >
                                                        <h4 className='neeporoalposttsheadr'>{enquiryItem?.enqueryByData?.personName}</h4>
                                                        <p className='cmskshhstdiifgysyttxtpop'>Enquiry on: {moment(enquiryItem?.PostData?.createdOn).format('DD-MMM-YYYY')}</p>
                                                    </div>
                                                </div>

                                                <div className='allpostowndmaimndivallelemnt mt-4'>
                                                    <div className='allpostowndmaimndivallelemnt'>
                                                        <p><strong>Name:</strong> {enquiryItem?.name}<br /><strong>Phone:</strong> {enquiryItem?.phoneNo}<br /><strong>Email:</strong> {enquiryItem?.workEmail}</p>
                                                    </div>

                                                    <div className='crosasddoproidikdsjbhidivflx'>
                                                        <div className='crossidovpostimgdiv' onClick={(e) => deleteEnquiry(e, enquiryItem?._id)} style={{ cursor: "pointer" }}>
                                                            <img src={crosssimgiocn} alt='close button' />
                                                        </div>
                                                    </div>
                                                </div>

                                                <div className='postbannettimhdivflxmakflx'>
                                                    {/* <div className='postbanneimmhgdivjakhjimh'
                                                        onClick={(e) => handleopwmnpostmodal(e, enquiryItem)}
                                                    >
                                                        <img src={enquiryItem?.file || postbanneimmhg} alt='' style={{ borderRadius: "12px", cursor: "pointer" }} />
                                                    </div> */}
                                                    <div className='poosttalouindtdettstctpopdoiv'>
                                                        <p><strong>Type: </strong>{enquiryItem?.typeOfEnquiry || ""}</p>
                                                        <p><strong>Subject: </strong>{enquiryItem?.enquirySubject || ""}</p>
                                                        <p><strong>Message: </strong>
                                                            {enquiryItem?.enquiry || "..."}
                                                        </p>
                                                        {enquiryItem?.file &&
                                                            <div className='_postbanneimmhgdivjakhjimh' onClick={() => openModal(enquiryItem?.file || postbanneimmhg)} >
                                                                <img src={enquiryItem?.file || postbanneimmhg} alt='' style={{ borderRadius: "8px", cursor: "pointer", maxWidth: "64px" }} />
                                                            </div>
                                                        }
                                                    </div>
                                                </div>

                                                <div className=''>
                                                    <p className='htrrstrtdttgsgbtxttppgh'>{formatDateAgo(enquiryItem?.createdOn)}</p>
                                                </div>
                                                <div className="allpostlikecommetsendenqeryudiv"></div>
                                            </div>
                                        </>
                                    )
                                })
                            }
                        </div>

                        {isModalOpen && (
                            <div
                                style={{
                                    position: "fixed",
                                    top: 0,
                                    left: 0,
                                    width: "100vw",
                                    height: "100vh",
                                    backgroundColor: "rgba(0, 0, 0, 0.8)",
                                    display: "flex",
                                    justifyContent: "center",
                                    alignItems: "center",
                                    zIndex: 1000,
                                }}
                                onClick={closeModal}
                            >
                                <img
                                    src={selectedImage}
                                    alt="Large View"
                                    style={{
                                        maxWidth: "90%",
                                        maxHeight: "90%",
                                        boxShadow: "0 4px 8px rgba(0, 0, 0, 0.5)",
                                    }}
                                />
                            </div>
                        )}
                    </>
                )
            }

        </>
    )
}

export default BlmPageEnquiries
